export default "__VITE_ASSET__QMBp_Oys__"